export class GallerySelect {
    constructor(optionalOptions = {}) {
        this.gallery = document.querySelectorAll('.gallery-selectable');

        if (!this.gallery) {
            this.destructor();
            return true;
        }

        let items
        let counter = 0;
        let galleryGrid

        let isAlwaysSelectedArea = false
        let setActiveButton = false
        let activeBlock;

        this.gallery.forEach((gallery) => {
            items = gallery.querySelectorAll('.gallery-add--item');

            galleryGrid = gallery.querySelector('.gallery-add--grid')

            if (galleryGrid.classList.contains('to-select')) {
                isAlwaysSelectedArea = true
            }

            if (galleryGrid.dataset.active) {
                setActiveButton = true
                activeBlock = document.querySelector(galleryGrid.dataset.active);
            }

            if (items) {
                items.forEach((item) => {
                    item.addEventListener("click", (event) => {
                       event.preventDefault()

                        items.forEach((itemFirst) => {
                            itemFirst.classList.remove('last-click')
                        })

                        if (item.parentNode.classList.contains('gallery-add-grid--crop')) {
                            if (item.classList.contains('selected')) {
                                item.classList.remove('selected')
                                item.querySelector('.select-indicator').innerHTML = ""

                                return false
                            } else {
                                items.forEach((itemFirst) => {
                                    itemFirst.classList.remove('selected')
                                })

                                item.classList.add('selected')

                                if (item.dataset.src) {
                                    if (gallery.querySelector('.gallery-add--big')) {
                                        let images = gallery.querySelectorAll('.gallery-add--big img')
                                        images.forEach((image) => {
                                            image.src = item.dataset.src;
                                        })
                                    }
                                }

                                return false
                            }
                        }

                        if (item.classList.contains('selected')) {
                            counter = (counter <= 0 ? 0 : counter - 1)
                            item.classList.remove('selected')
                            item.querySelector('.select-indicator').innerHTML = ""
                        } else {
                            if (counter === 10) {
                                window.showModal('modal-gallery-select-limit')
                                return false
                            }

                            item.classList.add('last-click')

                            if (item.dataset.src) {
                                if (gallery.querySelector('.gallery-add--big')) {
                                    gallery.querySelector('.gallery-add--big img').src = item.dataset.src;
                                }
                            }

                            counter++;
                            item.classList.add('selected')
                            item.querySelector('.select-indicator').innerHTML = counter
                        }

                        galleryGrid = gallery.querySelector('.gallery-add--grid')

                        if (gallery.querySelector('.gallery-add--item.selected')) {
                            if (setActiveButton) {
                                activeBlock.classList.add('selected')
                            }
                        }

                        if (gallery.querySelector('.gallery-add--item.selected') && !galleryGrid.classList.contains('to-select')) {
                            if (counter >= 2) {
                                galleryGrid.classList.add('to-select');
                            }
                        } else if (galleryGrid.classList.contains('to-select') && !gallery.querySelector('.gallery-add--item.selected')) {
                            if (!galleryGrid.classList.contains('gallery-add-grid--instagram')) {
                                if (!isAlwaysSelectedArea) {
                                    galleryGrid.classList.remove('to-select');
                                }

                                if (setActiveButton) {
                                    activeBlock.classList.remove('selected')
                                }
                            }
                        }
                    })
                })
            }
        })
    }

    destructor() {
        this.gallery = null;
    }
}

export default new GallerySelect();